<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"/>

    <div id="dibs-complete-checkout"></div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';

export default {
  name: 'CheckoutStartupFee',

  data () {
    return {
      isLoading: false,
      fullPage: true,
      bookedId: null,
      paymentId: null,
      checkoutKey: null,
      selfRedirect: false,
      dibsReady: false,
      checkingInterval: null,
    }
  },

  components: {
    Loading
  },

  created: function () {
    let checkoutUrl = 'https://test.checkout.dibspayment.eu/v1/checkout.js?v=1'

    if (process.env.NODE_ENV === 'demo' || process.env.NODE_ENV === 'production') {
      checkoutUrl = 'https://checkout.dibspayment.eu/v1/checkout.js?v=1'
    }

    let script = document.createElement('script')
    script.setAttribute('src', checkoutUrl)
    document.head.appendChild(script)
  },

  mounted() {
    const body = document.querySelector('body')
    body.classList.remove('not-scrollable')
    this.isLoading = true

    let queryParams = this.$route.params
    const id = queryParams.id

    this.createPayment(id).then((response) => {
      this.bookedId = response.data.id
      this.paymentId = response.data.payment_id
      this.checkoutKey = response.data.checkout_key

      this.checkDibsIsReady()
    }).catch(() => {
      this.selfRedirect = true
      setTimeout(() => {
        this.$router.push({name: 'dashboard'})
      }, 3000)
    })
  },

  watch: {
    dibsReady(val) {
      if (val) {
        clearInterval(this.checkingInterval)
        this.initCheckout()
      }
    }
  },

  methods: {
    checkDibsIsReady() {
      let $this = this

      this.checkingInterval = setInterval(function() {
        if (Dibs) {
          $this.isLoading = false
          $this.dibsReady = true
        }
      }, 1000) //or whatever interval you want to check
    },

    createPayment (id) {
      return new Promise((resolve, reject) => {
        this.axios.post(`booked/${id}/startup-fee/payment`).then((response) => {
          resolve(response)
        }).catch((error) => {
          if (error.response) {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: error.response.data.message,
              type: 'error',
              align: 'right'
            })
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })
          }

          reject(error)
        })
      })
    },

    initCheckout () {
      var checkoutOptions = {
        checkoutKey: this.checkoutKey,
        paymentId: this.paymentId,
        containerId: 'dibs-complete-checkout',
        language: 'da-DK'
      }

      try {
        /*eslint-disable */
        var checkout = new Dibs.Checkout(checkoutOptions)
        /* eslint-enable */

        checkout.on('payment-completed', ({paymentId}) => {
          this.isLoading = true

          let data = {
            payment_id: paymentId
          }

          this.axios.post(`booked/${this.bookedId}/startup-fee/charge`, data)
            .then(() => {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.success.success'),
                message: 'Startup fee charged successfully!',
                type: 'success',
                align: 'right'
              })

              this.activateBooked(this.bookedId).then((response) => {
                this.$events.$emit('booking-reserved', response.data.data)
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.success.success'),
                  message: this.$t('pages.bookings.validation.success.booking_added_free'),
                  type: 'success',
                  align: 'right'
                })

                this.selfRedirect = true
                setTimeout(() => {
                  this.$router.push({name: 'bookings'})
                }, 3000)
              }).catch((error) => {
                if (error.response.data.message) {
                  this.$events.$emit('alert', {
                    header: this.$t('globals.validation.errors.error'),
                    message: error.response.data.message,
                    type: 'error',
                    align: 'right'
                  })
                }
                setTimeout(() => {
                  this.$router.push({name: 'bookings'})
                }, 3000)
              })
            }).catch((error) => {
            if (error.response.data.message) {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.errors.error'),
                message: error.response.data.message,
                type: 'error',
                align: 'right'
              })
            } else {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.errors.something_went_wrong'),
                message: this.$t('globals.validation.errors.try_again_later'),
                type: 'error',
                align: 'right'
              })
            }

            this.selfRedirect = true
            setTimeout(() => {
              this.$router.push({name: 'bookings'})
            }, 3000)
          })
        })
      } catch (e) {
        console.log(e)

        this.$events.$emit('alert', {
          header: this.$t('globals.validation.errors.something_went_wrong'),
          message: this.$t('globals.validation.errors.try_again_later'),
          type: 'error',
          align: 'right'
        })

        setTimeout(() => {
          this.terminatePayment('dashboard')
        }, 3000)
      }
    },

    activateBooked (bookedId) {
      return new Promise((resolve, reject) => {
        this.axios.put(`/booked/${bookedId}/activate`)
          .then((response) => {
            resolve(response)
          }).catch((error) => {
          reject(error)
        })
      })
    },

    terminatePayment (to) {
      return new Promise((resolve, reject) => {
        let data = {
          paymentId: this.paymentId
        }

        this.axios.put(`booked/${this.bookedId}/terminatePayment`, data)
          .then((response) => {
            if (response.status === 204) {
              this.selfRedirect = true
              this.$router.push({name: to.name}, () => {
                window.location.reload(true)
              })
            }
            resolve(response)
          }).catch((error) => {
          if (error.response) {
            if (error.response.data.message) {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.errors.error'),
                message: error.response.data.message,
                type: 'error',
                align: 'right'
              })
            }
          }
          setTimeout(() => this.logOut(), 3000)
          reject(error)
        })
      })
    },
    logOut () {
      this.$auth.logout({
        makeRequest: true,
        redirect: {name: 'login'}
      })

      // Reset merchants from store -- In addition to vuex-persisted-state
      this.$store.dispatch('resetMerchants')
      this.$store.dispatch('resetMerchant')
    },
  },

  beforeRouteLeave (to, from, next) {
    if (!this.selfRedirect) {
      const answer = window.confirm(this.$t('globals.confirm.confirm_leave').toString())
      if (answer) {
        this.terminatePayment(to)
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/payment/CheckoutStartupFee.vue